import React from "react";
import Loader from "../../../commons/loader";
import Service from "./Services";

export default class AktivalPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      allapot: null,
    };

    this.centerCSS = {
      width: '100%',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    }

    this.messages = {
      JO: 'Az Ön által megadott e-mail címen értesítjük, miután dolgozónk megerősítette a foglalását. Önnek további teendője nincs.',
      PARAM: 'Hiányos paraméter, kérjük nyissa meg újra a kiküldött linket!',
      FOGLALT: 'Az időpont már foglalásra került. Kérjük tegyen új foglalást más időpontban!',
      NEM_TALALHATO: 'A keresett foglalás nem található, túl sok idő telt el a foglalás és az aktiválás között, nem elérhető már vagy módosultak a feltételek. Kérjük tegyen új foglalást!',
      INTERVALLUM: 'A foglalási folyamat közben az időpont módosult. Kérjük tegyen új foglalást!',
      EGYEB: 'Váratlan hiba történt. Kérjük tegyen új foglalást!',
    }

    this.allapotEnum = {
      JO: 'JO',
      PARAM: 'PARAM',
      FOGLALT: 'FOGLALT',
      NEM_TALALHATO: 'NEM_TALALHATO',
      EGYEB: 'EGYEB'
    }
  }

  componentDidMount() {
    this.activateFoglalas();
  }

  activateFoglalas = () => {
    let paramName = 'hash';
    let params = new URL(window.location.href).searchParams;
    if (!params.has(paramName)) {
      this.setState({ loading: false, allapot: this.allapotEnum.PARAM });
    } else {
      let hash = params.get(paramName);
      Service.activateFoglalas(hash, (err, res) => {
        if (!err) {
          this.setState({ loading: false, allapot: res[0] });
        } else {
          this.setState({ loading: false, allapot: this.allapotEnum.EGYEB });
        }
      });
    }
  }

  renderAllapot = (allapot) => {
    switch (allapot) {
      case this.allapotEnum.JO:
        return this.renderSiker();
      case this.allapotEnum.PARAM:
        return this.renderParamHiba();
      default:
        // Az EGYEB default-ként szolgál, ha az allapot-ra nem található üzenet
        return this.renderHiba(this.messages[allapot] || this.messages[this.allapotEnum.EGYEB]);
    }
  }

  renderParamHiba = () => {
    return this.renderFeedback('Hibás URL!', this.messages[this.allapotEnum.PARAM], 'x_icon.svg');
  }

  renderHiba = (text) => {
    return this.renderFeedback('Sikertelen aktiválás!', text, 'x_icon.svg');
  }

  renderSiker = () => {
    return this.renderFeedback(
      'Sikeres aktiválás!',
      this.messages[this.allapotEnum.JO],
      'mail-sent.svg'
    );
  }

  renderFeedback = (title, text, imgName) => {
    return <div className="empty-state animated fadeIn">
      <img
        src={process.env.PUBLIC_URL + '/img/' + imgName}
        className="img-fluid"
        alt="img-avatar"
      />
      <h3>{title}</h3>
      <h5>{text}</h5>
    </div>;
  }

  render() {
    const { loading } = this.state;
    return <div style={this.centerCSS}>
      {loading && <Loader loaderStyle={{ width: 250 }} />}
      {!loading && this.renderAllapot(this.state.allapot)}
    </div>;
  }
}
